import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/very-dissatisfied.vue
var s = {
	name: "DtIconVeryDissatisfied",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--very-dissatisfied"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Very Dissatisfied",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.899 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.399 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm2.435-1.777a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693Zm4 0a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693ZM5.899 6a2.641 2.641 0 0 0-1.608.517c-.46.345-.78.836-.883 1.39a.5.5 0 0 0 .49.593h4a.5.5 0 0 0 .492-.592 2.268 2.268 0 0 0-.883-1.39A2.641 2.641 0 0 0 5.9 6Zm-.006 1a1.642 1.642 0 0 0-1.002.317 1.41 1.41 0 0 0-.201.183h2.418a1.409 1.409 0 0 0-.2-.183A1.642 1.642 0 0 0 5.904 7h-.012Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=very-dissatisfied.js.map